import {ISession} from 'models';

/**
 * Websocket payloads carry null series fields for everyone (no viewer), which
 * would wipe the series owner's stored values. When the incoming payload has
 * both null/undefined, keep what is already stored; otherwise the payload wins.
 */
export const mergeSeriesFields = <T extends Partial<ISession>>(
    stored: Partial<ISession> | undefined | null,
    incoming: T,
): T => {
    if (!stored) return incoming;
    if (
        incoming.focus_session_repeat_parent != null ||
        incoming.repeat_config != null
    ) {
        return incoming;
    }
    return {
        ...incoming,
        focus_session_repeat_parent: stored.focus_session_repeat_parent ?? null,
        repeat_config: stored.repeat_config ?? null,
    };
};
